import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Logo from '../../../assets/pictures/Logo-bw.png';

// Formatea números como moneda DOP
function formatCurrency(value) {
  if (value === null || value === undefined) return 'RD$ 0.00';
  let numValue = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : Number(value);
  if (isNaN(numValue)) numValue = 0;
  return `RD$ ${numValue.toLocaleString('es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

// Capitaliza la primera letra
function capitalize(str) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

// Obtiene el mes y año de facturación del primer registro
function getMonthYear(invoiceData) {
  if (!invoiceData || !invoiceData.length) return '';
  const date = new Date(invoiceData[0].invoiceDate);
  return date.toLocaleString('es-DO', { month: 'long', year: 'numeric' });
}

export const exportInvoiceReportToPdf = (invoiceData) => {
  // Horizontal (landscape) y tamaño A4
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });

  // === DISCLAMER DE PRÁCTICA ===
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text("*** VERSIÓN DE PRÁCTICA ***", 14, 8);
  doc.setFont('helvetica', 'normal');
  doc.text("Esta es una versión de práctica. Los datos son ficticios.", 14, 12);
  doc.text("Generado el: " + new Date().toLocaleDateString('es-DO'), 14, 16);

  // Logo y nombre de empresa
  if (Logo) {
    const logoWidth = 28;
    const aspectRatio = 214 / 396;
    const logoHeight = logoWidth * aspectRatio; // ≈ 15.14mm
    doc.addImage(Logo, 'PNG', 14, 8, logoWidth, logoHeight);
  }
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text("D'Princess Santiago (PRÁCTICA)", 45, 22);

  doc.setFontSize(20);
  doc.setFont('helvetica', 'normal');
  doc.text('Reporte de Facturas (PRÁCTICA)', 14, 42);

  // Mes de facturación
  const mesFacturacion = getMonthYear(invoiceData);
  doc.setFontSize(12);
  doc.text(`Mes de facturación: ${capitalize(mesFacturacion)}`, 14, 52);

  const tableColumn = [
    "Numero de factura",
    "Nombre del Cliente",
    "Monto Total",
    "Monto Pagado",
    "Monto Pendiente",
    "Estado de Pago"
  ];
  const tableRows = [];

  invoiceData.forEach(invoice => {
    const row = [
      invoice.invoiceNumber,
      invoice.clientName,
      formatCurrency(invoice.totalAmount),
      formatCurrency(invoice.paidAmount),
      formatCurrency(invoice.pendingAmount),
      capitalize(invoice.paymentStatus)
    ];
    tableRows.push(row);
  });

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 58,
    styles: { fontSize: 10 },
    headStyles: { fillColor: [76, 0, 130] }, // morado
    alternateRowStyles: { fillColor: [243, 232, 255] }, // lila claro
    margin: { left: 14, right: 14 }
  });

  // === DISCLAMER FINAL ===
  const finalY = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.text("*** VERSIÓN DE PRÁCTICA *** - Datos ficticios para demostración", 14, finalY);
  doc.text("Este documento es generado por el sistema de práctica y no tiene validez legal.", 14, finalY + 4);

  doc.save(`invoice_report_${new Date().toISOString().slice(0, 10)}.pdf`);
};

export const exportDailyPaymentsToPdf = (paymentsData) => {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });

  // === DISCLAMER DE PRÁCTICA ===
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text("*** VERSIÓN DE PRÁCTICA ***", 14, 8);
  doc.setFont('helvetica', 'normal');
  doc.text("Esta es una versión de práctica. Los datos son ficticios.", 14, 12);
  doc.text("Generado el: " + new Date().toLocaleDateString('es-DO'), 14, 16);

  // Logo y nombre de empresa
  if (Logo) {
    const logoWidth = 28;
    const aspectRatio = 214 / 396;
    const logoHeight = logoWidth * aspectRatio;
    doc.addImage(Logo, 'PNG', 14, 8, logoWidth, logoHeight);
  }
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text("D'Princess Santiago (PRÁCTICA)", 45, 22);

  doc.setFontSize(20);
  doc.setFont('helvetica', 'normal');
  doc.text('Reporte de Pagos Diarios (PRÁCTICA)', 14, 42);

  // Fecha del reporte (hoy)
  const fechaHoy = new Date();
  const fechaStr = fechaHoy.toLocaleDateString('es-DO', { day: '2-digit', month: 'long', year: 'numeric' });
  doc.setFontSize(12);
  doc.text(`Fecha del reporte: ${capitalize(fechaStr)}`, 14, 52);

  const tableColumn = [
    "Fecha y Hora",
    "Factura",
    "Cliente",
    "Método de Pago",
    "Monto",
    "Descripción", // Nueva columna
    "Atendido por"
  ];
  const tableRows = [];

  paymentsData.forEach(payment => {
    tableRows.push([
      payment.creationDate
        ? new Date(payment.creationDate).toLocaleString('es-DO', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' })
        : 'N/A',
      payment.invoiceNumber,
      payment.clientName,
      capitalize(payment.paymentMethod || 'Efectivo'),
      formatCurrency(payment.amount),
      payment.description || '—', // Nueva columna
      payment.employeeName || 'N/A'
    ]);
  });

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 58,
    styles: { fontSize: 10 },
    headStyles: { fillColor: [76, 0, 130] },
    alternateRowStyles: { fillColor: [243, 232, 255] },
    margin: { left: 14, right: 14 }
  });

  // === DISCLAMER FINAL ===
  const finalY = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.text("*** VERSIÓN DE PRÁCTICA *** - Datos ficticios para demostración", 14, finalY);
  doc.text("Este documento es generado por el sistema de práctica y no tiene validez legal.", 14, finalY + 4);

  doc.save(`pagos_diarios_${new Date().toISOString().slice(0, 10)}.pdf`);
};

export const exportMonthlyPaymentsToPdf = (paymentsData) => {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });

  // === DISCLAMER DE PRÁCTICA ===
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text("*** VERSIÓN DE PRÁCTICA ***", 14, 8);
  doc.setFont('helvetica', 'normal');
  doc.text("Esta es una versión de práctica. Los datos son ficticios.", 14, 12);
  doc.text("Generado el: " + new Date().toLocaleDateString('es-DO'), 14, 16);

  // Logo y nombre de empresa
  if (Logo) {
    const logoWidth = 28;
    const aspectRatio = 214 / 396;
    const logoHeight = logoWidth * aspectRatio;
    doc.addImage(Logo, 'PNG', 14, 8, logoWidth, logoHeight);
  }
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text("D'Princess Santiago (PRÁCTICA)", 45, 22);

  doc.setFontSize(20);
  doc.setFont('helvetica', 'normal');
  doc.text('Reporte Mensual de Pagos (PRÁCTICA)', 14, 42);

  // Mes del reporte (tomado del primer pago)
  let mesReporte = '';
  if (paymentsData && paymentsData.length > 0 && paymentsData[0].paymentDate) {
    const date = new Date(paymentsData[0].paymentDate);
    mesReporte = date.toLocaleString('es-DO', { month: 'long', year: 'numeric' });
  }
  doc.setFontSize(12);
  doc.text(`Mes del reporte: ${capitalize(mesReporte)}`, 14, 52);

  const tableColumn = [
    "Fecha y Hora",
    "Factura",
    "Cliente",
    "Método de Pago",
    "Monto",
    "Descripción",
    "Atendido por"
  ];
  const tableRows = [];

  paymentsData.forEach(payment => {
    tableRows.push([
      payment.paymentDate
        ? new Date(payment.paymentDate).toLocaleString('es-DO', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' })
        : 'N/A',
      payment.invoiceNumber,
      payment.clientName,
      capitalize(payment.paymentMethod || 'Efectivo'),
      formatCurrency(payment.amount),
      payment.description || '—',
      payment.employeeName || 'N/A'
    ]);
  });

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 58,
    styles: { fontSize: 10 },
    headStyles: { fillColor: [76, 0, 130] },
    alternateRowStyles: { fillColor: [243, 232, 255] },
    margin: { left: 14, right: 14 }
  });

  // === DISCLAMER FINAL ===
  const finalY = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.text("*** VERSIÓN DE PRÁCTICA *** - Datos ficticios para demostración", 14, finalY);
  doc.text("Este documento es generado por el sistema de práctica y no tiene validez legal.", 14, finalY + 4);

  doc.save(`pagos_mensuales_${new Date().toISOString().slice(0, 10)}.pdf`);
};